module.exports = __webpack_public_path__ + "static/img/Improved Efficiency.4f905f6e.webp";